import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardText, Row, Col } from 'reactstrap';
import { metadataService } from "../../_services";
import { SlSectionTitle, TextInput, SelectInput, ReadOnlyField, SlYesNo, SlFormEntryRow, SlRadioButton , SlMoneyInput, SlDropdown} from "../editors"
import validator from "validator";

export class EditProfileInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rentOrOwn: {
                rent: 0,
                own: 1
            },
            fieldErrors:[],
            isResidenceTypeOpen : false,
        };
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.getCityState = this.getCityState.bind(this);
        this.formValidationformValidation = this.formValidation.bind(this);
    }

    componentDidMount() {
        let updatedProfile = { ...this.props.profile }; 
        this.formValidation(this.props.profile.postalCode);
        this.props.onChange(updatedProfile);
    }

    formValidation(postalCode) {
        let fieldErrors = [];

        if (postalCode) {
            if (!validator.isPostalCode(postalCode, "US")) {
                fieldErrors.push({ fieldName: "PostalCode", messageName: "PostalCodeError" });
            }
        }

        this.setState({ fieldErrors: fieldErrors });
    }

    getCityState(zipCode) {
        metadataService.getCityStateByZip(zipCode).then(response => {
            var data = response.data;
            if (data) {

                const formValue = this.state.formValue;
                let newState = {
                    formValue: formValue
                };

                this.handleUpdate({ target: { name: "City", value: data.city } });
                this.handleUpdate({ target: { name: "State", value: data.state } });
            }
        });
    }

    handleOnBlur = ({ target: { name, value } }) => {

        if (name === "PostalCode" && value && value.length === 5) {
            this.getCityState(value);
        }

        this.setState({ visited: true });
    }

    handleUpdate(e){
        let updatedProfile = { ...this.props.profile };
        //first letter small. 
        const targetFieldName = e.target.name.substr(0, 1).toLowerCase() + e.target.name.substr(1); 
        if(targetFieldName === 'mobileOptIn'){
          updatedProfile[targetFieldName] = e.target.value === 'true';   
        }
        else if (targetFieldName === "rentOrOwn") {
            updatedProfile[targetFieldName] = parseInt(e.target.value);
        }else{
          updatedProfile[targetFieldName] = e.target.value; 
        }

        //additional validations
        this.formValidation(updatedProfile.postalCode);

        //tell parent of change
        this.props.onChange(updatedProfile);
    };

    render(){
        return (
            <div>
                <SlSectionTitle sectionName="ChangeMyInfo" />
                <Card>
                    <CardBody>
                        <ReadOnlyField name="FullName" value={this.props.profile.fullName} showFieldLabel={false}></ReadOnlyField>
                        <ReadOnlyField name="EmailAddress" value={this.props.profile.email}></ReadOnlyField>
                    </CardBody>

                    {this.props.profile.mobilePhone != null && (
                        <CardBody>
                            <ReadOnlyField name="MobilePhone" value={this.props.profile.mobilePhone + ""}></ReadOnlyField>
                        </CardBody>
                        )
                    }
                        
                </Card>
                <Card>
                    <CardBody className="noPadBottom">
                        <SlFormEntryRow>
                            <TextInput
                                name="Address1"
                                label={metadataService.getFieldNameLabel("Address")}
                                value={this.props.profile.address1 + ""}
                                onChange={this.handleUpdate}/>
                        </SlFormEntryRow>
                        {/*<SlFormEntryRow>*/}
                        {/*    <TextInput*/}
                        {/*        name="Address2"*/}
                        {/*        value={this.props.profile.address2 ? + this.props.profile.address2 : ""}*/}
                        {/*        onChange={this.handleUpdate}*/}
                        {/*        isRequired={false} />*/}
                        {/*</SlFormEntryRow>*/}
                        <SlFormEntryRow>
                            <TextInput
                                name="PostalCode"
                                value={this.props.profile.postalCode + ""}
                                onChange={this.handleUpdate}
                                onBlur={this.handleOnBlur}
                                type="number"
                                maxLength={5}
                                fieldErrors={this.state.fieldErrors} />
                        </SlFormEntryRow>
                        <SlFormEntryRow>
                            <TextInput
                                name="City"
                                value={this.props.profile.city + ""}
                                onChange={this.handleUpdate} />
                        </SlFormEntryRow>
                        <SlFormEntryRow>
                            <SelectInput 
                                name="State"
                                value={this.props.profile.state}
                                options={metadataService.getLookup("state")}
                                onChange={this.handleUpdate} />
                        </SlFormEntryRow>

                        <SlFormEntryRow>
                            <Row>
                                <Col xs={12} md={{ size: 10, offset: 1 }}>
                                    <SlSectionTitle sectionName="NumberOfYearsMonthsInHome" />
                                </Col>
                            </Row>
                        </SlFormEntryRow>
                        <SlFormEntryRow>
                            <Row>
                                <Col>
                                    <TextInput
                                        name="Years"
                                        type="number"
                                        label={metadataService.getFieldNameLabel("Years")}
                                        placeholder={metadataService.getFieldNameLabel("Years")}
                                        showLabel={true}
                                        isRequired={true}
                                        value={this.props.profile.years+""}
                                        onChange={this.handleUpdate}
                                        min={0}
                                        max={99}
                                        maxLength={2}
                                        disabled={false} />
                                </Col>
                                <Col>
                                    <TextInput
                                        name="Months"
                                        type="number"
                                        label={metadataService.getFieldNameLabel("Months")}
                                        placeholder={metadataService.getFieldNameLabel("Months")}
                                        value={this.props.profile.months+""}
                                        onChange={this.handleUpdate}
                                        isRequired={true}
                                        showLabel={true}
                                        min={0}
                                        max={11}
                                        maxLength={2}
                                        disabled={false} />
                                </Col>
                            </Row>
                        </SlFormEntryRow>
                        <SlFormEntryRow>
                            <Row>
                                <Col xs={12} md={{ size: 10, offset: 1 }}>
                                    <SlSectionTitle sectionName="DoYouRentOrOwn" />
                                </Col>
                            </Row>
                        </SlFormEntryRow>
                        {/* <SlFormEntryRow>
                            <Row>
                                <Col className={"text-center"}>
                                    <SlRadioButton
                                        fieldName='rentOrOwn'
                                        onChange={this.handleUpdate}
                                        disabled={this.props.readOnly}
                                        isSelected={this.props.profile.rentOrOwn === this.state.rentOrOwn.rent}
                                        value={this.state.rentOrOwn.rent.toString()}>
                                        {metadataService.getFieldNameLabel('Rent')}
                                    </SlRadioButton>
                                </Col>
                                <Col className={"text-center"}>
                                    <SlRadioButton
                                        fieldName='rentOrOwn'
                                        onChange={this.handleUpdate}
                                        disabled={this.props.readOnly}
                                        isSelected={this.props.profile.rentOrOwn === this.state.rentOrOwn.own}
                                        value={this.state.rentOrOwn.own.toString()}>
                                        {metadataService.getFieldNameLabel('Own')}
                                    </SlRadioButton>
                                </Col>
                            </Row>
                        </SlFormEntryRow> */}
                         <SlFormEntryRow>
                            <SlDropdown
                                        Name="ResidenceType"
                                        value={this.props.profile.residenceType + ""}
                                        isRequired={true}
                                        options={metadataService.getLookup("residenceType")}
                                        handleChange={this.handleUpdate}
                                        open={this.state.isResidenceTypeOpen}
                                        openDropdown={() => this.setState({isResidenceTypeOpen: !this.state.isResidenceTypeOpen})}
                                        showLabel={true}
                                        placeholder={"Select " + metadataService.getFieldNameLabel("ResidenceType")}
                            />
                         </SlFormEntryRow>
                        <SlFormEntryRow>
                            {
                                        Number(this.props.profile.residenceType + "") === metadataService.ENUM_RESIDENCE_TYPE.OWN 
                                        ? <SlMoneyInput
                                        name="MonthlyResidencePayment"
                                        type="number"
                                        label={metadataService.getFieldNameLabel("MonthlyMortgagePayment")}
                                        placeholder={metadataService.getFieldNameLabel("MonthlyMortgagePayment")}
                                        value={this.props.profile.monthlyResidencePayment} 
                                        isRequired={true}
                                        showLabel={true}
                                        onChange={this.handleUpdate}/>
                                        : Number(this.props.profile.residenceType + "") === metadataService.ENUM_RESIDENCE_TYPE.RENT ?
                                        <SlMoneyInput
                                        name="MonthlyResidencePayment"
                                        type="number"
                                        label={metadataService.getFieldNameLabel("MonthlyResidencePayment")}
                                        placeholder={metadataService.getFieldNameLabel("MonthlyResidencePayment")}
                                        value={this.props.profile.monthlyResidencePayment} 
                                        isRequired={true}
                                        showLabel={true}
                                        onChange={this.handleUpdate} />
                                        : <SlMoneyInput
                                        name="MonthlyResidencePayment"
                                        type="number"
                                        label={metadataService.getFieldNameLabel("MonthlyResidenceExpense")}
                                        placeholder={metadataService.getFieldNameLabel("MonthlyResidenceExpense")}
                                        value={this.props.profile.monthlyResidencePayment} 
                                        isRequired={true}
                                        showLabel={true}
                                        onChange={this.handleUpdate} />
                            }
                        </SlFormEntryRow>
                        {/* <SlFormEntryRow>
                            {this.props.profile.rentOrOwn === 0 ?
                                (<Row>
                                    <Col>
                                        <TextInput
                                            name="monthlyResidencePayment"
                                            type="number"
                                            label={metadataService.getFieldNameLabel("MonthlyRentalPayment")}
                                            placeholder={metadataService.getFieldNameLabel("MonthlyRentalPayment")}
                                            value={this.props.profile.monthlyResidencePayment}
                                            isRequired={true}
                                            showLabel={true}
                                            onChange={this.handleUpdate}
                                        />
                                    </Col>
                                </Row>
                                )
                                :
                                (<Row>
                                    <Col>
                                        <TextInput
                                            name="monthlyResidencePayment"
                                            type="number"
                                            label={metadataService.getFieldNameLabel("MonthlyMortgagePayment")}
                                            placeholder={metadataService.getFieldNameLabel("MonthlyMortgagePayment")}
                                            value={this.props.profile.monthlyResidencePayment}
                                            isRequired={true}
                                            showLabel={true}
                                            onChange={this.handleUpdate}
                                        />

                                    </Col>
                                </Row>
                                )}
                        </SlFormEntryRow> */}
                        <SlYesNo
                            name="SelectedLanguage"
                            value={String(this.props.profile.selectedLanguage|| "").toUpperCase()} 
                            trueValue='EN' falseValue='ES' trueText={metadataService.getLabel("English")} falseText={metadataService.getLabel("Spanish")}
                            onChange={this.handleUpdate} />
                    </CardBody>
                </Card>
            </div>
        )
    }
}

EditProfileInfo.propTypes = {
    profile: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}